import { PropsWithChildren } from 'react';

import { LoaderTraceLogo } from '@stratumn/atomic';
import { cn } from '@/shadcn/lib/utils';
import { useTheme } from '@/shadcn/theme/theme-provider';

type Props = PropsWithChildren<{
  loading?: boolean;
}>;

export const KanbanMain = ({ children, loading = false }: Props) => {
  const { theme } = useTheme();
  return (
    <>
      <div
        className={cn(
          'top-full-navbar linear 250ms fixed right-0 bottom-0 left-0 z-2 box-border flex h-[calc(100%-var(--spacing-full-navbar))] overflow-auto pr-[env(safe-area-inset-right)] pb-[env(safe-area-inset-bottom)] pl-[env(safe-area-inset-left)] opacity-100 transition-opacity duration-250',
          loading && 'opacity-0'
        )}
        aria-busy={loading}
      >
        {children}
      </div>
      <div
        className="top-full-navbar bg-primary-dark fixed right-0 bottom-0 left-0 overflow-hidden"
        role="none"
      >
        <div
          className="bg-primary-dark dark:bg-background h-full bg-[url('/src/assets/IndigoTrace_Map.svg')] bg-cover bg-center bg-no-repeat dark:brightness-50"
          role="none"
        >
          <div
            className={cn(
              'flex h-full items-center justify-center opacity-0 transition-opacity duration-250',
              loading && 'opacity-100'
            )}
          >
            <LoaderTraceLogo light={theme === 'dark'} />
          </div>
        </div>
      </div>
    </>
  );
};
